import React from 'react';
import { IOptionProps } from './types';

export default function OptionDropdown(props: IOptionProps) {
  const { label, onClick, active } = props;
  return (
    <li
      className={`${active ? 'active' : ''}`}
      onClick={() => onClick()}
    >{label}</li>
  )
}